// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"01477c14368766c4b3fb","655":"a6ebd1473eddbb93e1e7"}[chunkId] + ".js";
};